export const sliderSettings = {
  dots: false,
  nav: true,
  infinite: false,
  speed: 500,
  slidesToShow: 10,
  slidesToScroll: 5,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        dots: false,
        nav: true,
      }
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        nav: true,
      }
    },
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 10,
        slidesToScroll: 5,
        infinite: true,
        dots: false,
        nav: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};